import { settings } from "./settings";

let strings = {};

const loadTranslations = async (market) => {
  const contentful = (entry) =>
    fetch(`${settings.contentfulApi}/entry/${entry}/${market}`);
  const [
    translations,
    singleFeeInformation,
    cycleMallorca,
    caxDescription,
    successDescription,
    sportsSocial,
    contactUsSports,
    contactUsGroups,
    legalDescription,
    importantDescription,
    importantTurkey,
    pageNotFound,
    descriptionWahlgren,
    descriptionAnnikaSjoo,
    travelInsuranceDescription,
    paymentTermsInfo,
    cancellationInfo,
    travelInsuranceInfo,
    localTaxesAndFeesInfo,
  ] = await Promise.all([
    contentful("3yl5numip4FGNe2znpqBKi").then((res) => res.json()),
    contentful("2ugqHsd0Xxw06LUaqL8e52").then((res) => res.text()),
    contentful("x9yidsLldnaAcSENeMGAY").then((res) => res.text()),
    contentful("41TFR2VOXwJgqbUDV01q6F").then((res) => res.text()),
    contentful("17qHd0EL9tcyTYw3nMlg4i").then((res) => res.text()),
    contentful("6efWowykYfQNRJHgy53o33").then((res) => res.text()),
    contentful("26bNhDLghS0EjSsXsaYgpb").then((res) => res.text()),
    contentful("1r2aCcuxVFu1XjIX4HUAxE").then((res) => res.text()),
    contentful("23dI13xBQdY9kNTHYNarHY").then((res) => res.text()),
    contentful("55Wf9a8JRXNzzCDqOpwRwS").then((res) => res.text()),
    contentful("4EWegdpLaDl71n6leAPUha").then((res) => res.text()),
    contentful("22caNBQmCL4KuiKKq8uldE").then((res) => res.text()),
    contentful("7bSN7FAZO27x7h4N0vpT1K").then((res) => res.text()),
    contentful("suax3Z3fy0SqQsVD7HDnF").then((res) => res.text()),
    contentful("5NzvNeRSd195u52jDQznKi").then((res) => res.text()),
    contentful("2MUZajUyQmZBgroi5kQhLd").then((res) => res.text()),
    contentful("4UKh3ZKI84nSsIsUPpH9jj").then((res) => res.text()),
    contentful("1FTHUqR6IjNyOZPXpHBI78").then((res) => res.text()),
    contentful("2biPmtV1pQpiMj7rtvN9FN").then((res) => res.text()),
  ]);
  strings = {
    ...translations,
    singleFeeInformation,
    cycleMallorca,
    caxDescription,
    successDescription,
    sportsSocial,
    contactUsSports,
    contactUsGroups,
    legalDescription,
    importantDescription,
    importantTurkey,
    pageNotFound,
    descriptionWahlgren,
    descriptionAnnikaSjoo,
    travelInsuranceDescription,
    paymentTermsInfo,
    cancellationInfo,
    travelInsuranceInfo,
    localTaxesAndFeesInfo,
  };
};

export { loadTranslations, strings };
